(() => {
  const widget = document.querySelector('[data-aihm-location-widget]');
  if (!widget) return;
  const drawer = widget.querySelector('.aihm-loc-drawer');
  const backdrop = widget.querySelector('.aihm-loc-backdrop');
  const toast = widget.querySelector('.aihm-loc-toast');
  const search = widget.querySelector('[data-aihm-loc-search]');
  const message = widget.querySelector('[data-aihm-loc-message]');
  const noResults = widget.querySelector('[data-aihm-loc-no-results]');
  const cards = [...widget.querySelectorAll('.aihm-loc-card')];
  const savedKey = 'aihm_preferred_clinic_v1';
  let lastFocus = null;
  let oldOverflow = '';
  const saved = (() => { try { return localStorage.getItem(savedKey); } catch (_) { return null; } })();
  const selected = cards.find(card => card.dataset.key === saved);
  let activeClinic = selected || null;
  if (selected) {
    widget.querySelector('[data-aihm-loc-greeting]').textContent = `Welcome to ${selected.querySelector('strong').textContent}`;
    widget.querySelector('[data-aihm-loc-summary]').textContent = 'Explore your AIHM clinic or choose another location.';
    selected.classList.add('is-selected');
  }
  function close() {
    if (drawer.getAttribute('aria-hidden') === 'true') return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.hidden = true;
    document.body.style.overflow = oldOverflow;
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  }
  function open() {
    lastFocus = document.activeElement;
    toast.hidden = true;
    oldOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    backdrop.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setTimeout(() => search.focus(), 60);
  }
  document.querySelectorAll('[data-aihm-loc-open]').forEach(button => button.addEventListener('click', () => {
    if (button.closest('.aihm-loc-toast') && activeClinic) {
      try { localStorage.setItem(savedKey, activeClinic.dataset.key); } catch (_) {}
      location.assign(activeClinic.querySelector('a').href);
      return;
    }
    open();
  }));
  // Availability opens the same drawer as the header button.
  widget.querySelectorAll('[data-aihm-loc-availability]').forEach(button => button.addEventListener('click', open));
  widget.querySelectorAll('[data-aihm-loc-close]').forEach(button => button.addEventListener('click', close));
  widget.querySelector('[data-aihm-loc-toast-close]').addEventListener('click', () => { toast.hidden = true; });
  document.addEventListener('keydown', event => {
    if (drawer.getAttribute('aria-hidden') === 'true') return;
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab') return;
    const controls = [...drawer.querySelectorAll('button, input, a')].filter(el => !el.closest('[hidden]') && !el.closest('li[hidden]'));
    if (!controls.length) return;
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  // Area and PIN searches are submitted explicitly, rather than on every keystroke.
  const searchForm = widget.querySelector('[data-aihm-loc-search-form]');
  const searchSubmit = widget.querySelector('[data-aihm-loc-search-submit]');
  const areaResults = widget.querySelector('[data-aihm-loc-area-results]');
  const searchCache = new Map();
  let searchRequest = null;
  let searchVersion = 0;
  let searchSnapshot = null;
  let lastRequestAt = 0;
  function normalise(value) {
    return String(value || '').normalize('NFKC').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  }
  function rememberClinicList() {
    if (searchSnapshot || !cards.length) return;
    searchSnapshot = {
      order: [...cards[0].parentElement.children].filter(card => cards.includes(card)),
      active: activeClinic,
      states: cards.map(card => [card, card.classList.contains('is-nearest'), card.classList.contains('is-selected')])
    };
  }
  function restoreClinicList() {
    if (!searchSnapshot) return;
    searchSnapshot.order.forEach(card => card.parentElement.appendChild(card));
    searchSnapshot.states.forEach(([card, nearest, selected]) => {
      card.classList.toggle('is-nearest', nearest);
      card.classList.toggle('is-selected', selected);
    });
    activeClinic = searchSnapshot.active;
    cards.forEach(card => card.querySelector('[data-aihm-loc-distance]')?.remove());
  }
  function cancelAreaSearch() {
    searchVersion++;
    if (searchRequest) searchRequest.abort();
    searchRequest = null;
    if (searchSubmit) searchSubmit.disabled = false;
    if (searchForm) searchForm.removeAttribute('aria-busy');
    if (areaResults) { areaResults.replaceChildren(); areaResults.hidden = true; }
  }
  function kilometres(latitude, longitude, card) {
    const a = Number(card.dataset.lat), b = Number(card.dataset.lon);
    if (![a, b, latitude, longitude].every(Number.isFinite)) return Infinity;
    const rad = Math.PI / 180;
    const h = Math.sin((a - latitude) * rad / 2) ** 2 + Math.cos(latitude * rad) * Math.cos(a * rad) * Math.sin((b - longitude) * rad / 2) ** 2;
    return 12742 * Math.asin(Math.min(1, Math.sqrt(h)));
  }
  function rankForArea(area) {
    const serviceCity = normalise(area.city);
    const state = normalise(area.state);
    // Noida / Greater Noida / Gautam Buddha Nagar are served by the listed Ghaziabad clinic.
    const noidaRegion = ['noida', 'greater noida'].includes(serviceCity) || /\bgautam buddha nagar\b/.test(normalise(area.label));
    const inCity = card => {
      const cardCity = normalise(card.dataset.serviceCity || card.dataset.city);
      return (noidaRegion && cardCity === 'ghaziabad') || (serviceCity && cardCity === serviceCity) || (state === 'delhi' && normalise(card.dataset.state) === 'delhi');
    };
    const ranked = cards.map(card => ({card, km: kilometres(area.lat, area.lon, card), sameCity: Boolean(inCity(card))}))
      .sort((a, b) => Number(b.sameCity) - Number(a.sameCity) || a.km - b.km);
    const valid = ranked.filter(item => Number.isFinite(item.km));
    if (!valid.length) { message.textContent = 'Clinic distances are unavailable. Please choose a listed clinic.'; return; }
    const nearest = valid[0].card;
    ranked.forEach(({card, km}) => {
      nearest.parentElement.appendChild(card);
      card.hidden = false;
      card.classList.toggle('is-nearest', card === nearest);
      card.classList.toggle('is-selected', card === nearest);
      let badge = card.querySelector('[data-aihm-loc-distance]');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'aihm-loc-card__distance';
        badge.setAttribute('data-aihm-loc-distance', '');
        card.querySelector('strong').insertAdjacentElement('afterend', badge);
      }
      badge.textContent = Number.isFinite(km) ? `Approx. ${km < 1 ? 'less than 1' : Math.round(km)} km away (straight-line)` : 'Distance unavailable';
    });
    activeClinic = nearest;
    noResults.hidden = true;
    areaResults.replaceChildren();
    areaResults.hidden = true;
    const title = nearest.querySelector('strong').textContent;
    message.textContent = `${valid[0].km <= 50 ? 'A clinic near you' : 'Nearest listed clinic'}: ${title}. Results for ${area.label}. Clinics serving the searched area appear first, followed by other locations. Distances are approximate, not road distances.`;
  }
  function parseAreas(data, query) {
    const pin = /^[1-9]\d{5}$/.test(query) ? query : null;
    const seen = new Set();
    return (Array.isArray(data.features) ? data.features : []).map(feature => {
      const p = feature.properties || {};
      const coordinates = feature.geometry?.coordinates || [];
      const lon = Number(coordinates[0]), lat = Number(coordinates[1]);
      if (String(p.countrycode || '').toUpperCase() !== 'IN' || coordinates.length < 2 || !Number.isFinite(lat) || !Number.isFinite(lon)) return null;
      if (pin && !String(p.postcode || '').split(/[;,\s]+/).includes(pin) && String(p.name || '').trim() !== pin) return null;
      const label = [...new Set([p.name, p.district, p.city, p.county, p.state, p.postcode].filter(Boolean))].join(', ');
      if (!label) return null;
      const id = `${label}:${lat.toFixed(4)}:${lon.toFixed(4)}`;
      if (seen.has(id)) return null;
      seen.add(id);
      const exact = normalise(p.name) === normalise(query);
      const score = pin ? 200 : exact ? (['city', 'county', 'district', 'locality'].includes(p.type) ? 120 : 100) : 0;
      return {score, label, lat, lon, city: p.city || (p.type === 'city' || p.osm_value === 'city' ? p.name : ''), state: p.state || ''};
    }).filter(Boolean).sort((a, b) => b.score - a.score).slice(0, 5);
  }
  function renderAreaChoices(areas, version) {
    if (!areas.length) {
      message.textContent = 'We could not identify that area or PIN code. Add the city name, or check the 6-digit PIN. You can still choose a clinic below.';
      return;
    }
    // Display clinic distances immediately; alternative places remain optional.
    rankForArea(areas[0]);
    if (areas.length < 2) return;
    const toggleItem = document.createElement('li');
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'aihm-loc-area-choice';
    toggle.textContent = 'Change searched area';
    toggle.setAttribute('aria-expanded', 'false');
    const choices = document.createElement('ul');
    choices.className = 'aihm-loc-area-results';
    choices.hidden = true;
    toggle.addEventListener('click', () => {
      choices.hidden = !choices.hidden;
      toggle.setAttribute('aria-expanded', String(!choices.hidden));
    });
    areas.forEach(area => {
      const item = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'aihm-loc-area-choice';
      button.textContent = area.label;
      button.addEventListener('click', () => { if (version === searchVersion) rankForArea(area); });
      item.appendChild(button);
      choices.appendChild(item);
    });
    toggleItem.appendChild(toggle);
    toggleItem.appendChild(choices);
    areaResults.appendChild(toggleItem);
    areaResults.hidden = false;
  }
  search.addEventListener('input', () => {
    cancelAreaSearch();
    restoreClinicList();
    cards.forEach(card => { card.hidden = false; });
    noResults.hidden = true;
    const q = search.value.trim();
    if (q) {
      rememberClinicList();
      message.textContent = 'Enter an area and city, or a 6-digit PIN code, then press Search.';
    } else {
      searchSnapshot = null;
      message.textContent = '';
    }
  });
  if (searchForm && areaResults && searchSubmit) searchForm.addEventListener('submit', async event => {
    event.preventDefault();
    const q = search.value.trim().replace(/\s+/g, ' ');
    if (q.length < 3 || q.length > 120 || (/^[\d\s–—-]+$/.test(q) && !/^[1-9]\d{5}$/.test(q))) {
      message.textContent = 'Enter at least 3 letters with a city name, or a valid 6-digit Indian PIN code.';
      return;
    }
    cancelAreaSearch();
    rememberClinicList();
    restoreClinicList();
    cards.forEach(card => { card.hidden = false; });
    noResults.hidden = true;
    const version = searchVersion;
    const cacheKey = normalise(q);
    if (searchCache.has(cacheKey)) { renderAreaChoices(searchCache.get(cacheKey), version); return; }
    if (Date.now() - lastRequestAt < 1500) { message.textContent = 'Please wait a moment before searching again.'; return; }
    lastRequestAt = Date.now();
    const controller = new AbortController();
    searchRequest = controller;
    const timer = setTimeout(() => controller.abort(), 10000);
    searchSubmit.disabled = true;
    searchForm.setAttribute('aria-busy', 'true');
    message.textContent = 'Finding your area…';
    try {
      const url = new URL(widget.dataset.geocodeUrl || 'https://photon.komoot.io/api/', location.origin);
      url.searchParams.set('q', /^noida\s*[/|]/i.test(q) ? 'Noida' : q.replace(/:+$/, ''));
      url.searchParams.set('countrycode', 'IN');
      url.searchParams.set('lang', 'en');
      url.searchParams.set('limit', '10');
      if (!/^\d{6}$/.test(q)) ['locality', 'district', 'city', 'county'].forEach(layer => url.searchParams.append('layer', layer));
      const response = await fetch(url.href, {signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer'});
      if (!response.ok) throw new Error('Geocoder unavailable');
      const areas = parseAreas(await response.json(), q);
      if (version !== searchVersion) return;
      if (searchCache.size >= 30) searchCache.delete(searchCache.keys().next().value);
      searchCache.set(cacheKey, areas);
      renderAreaChoices(areas, version);
    } catch (_) {
      if (version === searchVersion) message.textContent = 'Area search is temporarily unavailable. Please try again, use your current location, or choose a clinic below.';
    } finally {
      clearTimeout(timer);
      if (version === searchVersion) {
        searchRequest = null;
        searchSubmit.disabled = false;
        searchForm.removeAttribute('aria-busy');
      }
    }
  });
  cards.forEach(card => card.querySelector('a').addEventListener('click', () => {
    try { localStorage.setItem(savedKey, card.dataset.key); } catch (_) {}
  }));
  function showWelcome() {
    if (drawer.getAttribute('aria-hidden') === 'true') toast.hidden = false;
  }
  function setNearest(position) {
    const lat = position.coords.latitude * Math.PI / 180;
    const lon = position.coords.longitude * Math.PI / 180;
    const distance = card => {
      const a = Number(card.dataset.lat) * Math.PI / 180;
      const b = Number(card.dataset.lon) * Math.PI / 180;
      const h = Math.sin((a - lat) / 2) ** 2 + Math.cos(lat) * Math.cos(a) * Math.sin((b - lon) / 2) ** 2;
      return 12742 * Math.asin(Math.min(1, Math.sqrt(h)));
    };
    const rankedCards = [...cards].sort((a, b) => distance(a) - distance(b));
    const nearest = rankedCards[0];
    activeClinic = nearest;
    // Move existing cards, preserving their links, search state and listeners.
    const list = nearest.parentElement;
    rankedCards.forEach(card => list.appendChild(card));
    const km = Math.round(distance(nearest));
    const city = nearest.querySelector('strong').textContent;
    cards.forEach(card => {
      card.classList.toggle('is-nearest', card === nearest);
      card.classList.toggle('is-selected', card === nearest);
    });
    widget.querySelector('[data-aihm-loc-greeting]').textContent = km <= 50 ? `Hakim Suleman's clinic is near you in ${city}` : `Your nearest listed clinic is in ${city}`;
    widget.querySelector('[data-aihm-loc-summary]').textContent = km <= 50 ? 'Explore the clinic and book your appointment.' : `Approximately ${km} km away. Explore all clinic locations.`;
    message.textContent = `Nearest listed clinic: ${city} (approximately ${km} km). You can choose any clinic below.`;
    showWelcome();
  }
  widget.querySelector('[data-aihm-loc-detect]').addEventListener('click', () => {
    if (!navigator.geolocation) {
      message.textContent = 'Location is unavailable. Please choose your city.';
      return;
    }
    cancelAreaSearch();
    restoreClinicList();
    searchSnapshot = null;
    search.value = '';
    cards.forEach(card => { card.hidden = false; });
    noResults.hidden = true;
    message.textContent = 'Finding a nearby clinic…';
    navigator.geolocation.getCurrentPosition(position => {
      setNearest(position);
      toast.hidden = true;
      const nearest = widget.querySelector('.aihm-loc-card.is-nearest');
      if (nearest) nearest.scrollIntoView({block: 'nearest', behavior: 'smooth'});
    }, () => {
      message.textContent = 'Location access is unavailable. Search or choose a clinic below.';
    }, {timeout: 9000, maximumAge: 300000, enableHighAccuracy: false});
  });
  if (widget.dataset.home === 'true') {
    setTimeout(() => {
      if (!navigator.geolocation) { showWelcome(); return; }
      let settled = false;
      const fallback = setTimeout(() => {
        if (!settled) showWelcome();
      }, 11000);
      try {
        navigator.geolocation.getCurrentPosition(position => {
          settled = true;
          clearTimeout(fallback);
          if (!search.value.trim()) setNearest(position);
        }, () => {
          settled = true;
          clearTimeout(fallback);
          showWelcome();
        }, {timeout: 9000, maximumAge: 300000, enableHighAccuracy: false});
      } catch (_) {
        settled = true;
        clearTimeout(fallback);
        showWelcome();
      }
    }, 900);
  }
  // Select the requested clinic before waiting for images or the window load event.
  const key = new URLSearchParams(location.search).get('aihm_location');
  if (key && location.pathname.replace(/\/$/, '') === '/pages/clinics') {
    let attempts = 0;
    let finished = false;
    const reveal = () => {
      document.documentElement.classList.remove('aihm-clinic-route-pending');
      clearTimeout(window.aihmClinicRouteFallback);
    };
    const chooseClinic = () => {
      if (finished) return;
      const targets = [...document.querySelectorAll('[data-aihm-location]')];
      const target = targets.find(el => el.dataset.aihmLocation === key);
      const panels = [...document.querySelectorAll('[data-aihm-clinic]')];
      const panel = panels.find(el => el.dataset.aihmClinic === key);
      if (!target || !panel) { finished = true; reveal(); return; }
      target.click();
      if (!panel.hidden && panel.classList.contains('is-active') && target.classList.contains('is-active')) {
        finished = true;
        reveal();
        panel.scrollIntoView({block: 'start'});
      } else if (++attempts < 40) {
        setTimeout(chooseClinic, 50);
      } else {
        reveal();
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', chooseClinic, {once: true});
    } else {
      chooseClinic();
    }
  }
})();

// Keep the clinic-page URL in sync with the existing carousel selection.
(() => {
  if (location.pathname.replace(/\/$/, '') !== '/pages/clinics') return;
  document.addEventListener('aihm:location-change', event => {
    const clinicKey = event.detail && event.detail.location;
    if (typeof clinicKey !== 'string' || !clinicKey) return;
    const knownClinic = [...document.querySelectorAll('[data-aihm-location]')]
      .some(card => card.dataset.aihmLocation === clinicKey);
    if (!knownClinic) return;
    const url = new URL(location.href);
    url.searchParams.set('aihm_location', clinicKey);
    url.hash = 'aihm-clinics';
    if (url.href === location.href) return;
    // Preserve other query parameters and existing history state without a reload.
    try { history.replaceState(history.state, '', url.href); } catch (_) {}
  });
})();
